import NavLinks from "./NavLinks";

const DeskMenu = () => {
    return ( 
        <div className="desktop-menu">
            <NavLinks/>
        </div>
     );
}
 
export default DeskMenu;